module.exports = __webpack_public_path__ + "static/media/4.34248b6e.png";